




































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { BoletoEspecialDTO } from '@/interfaces/BoletoEspecial.interface'
import HTTP from '@/plugins/axios'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'
import ErrorMixin from '@/mixins/Error'

@Component({
  mixins: [
    ErrorMixin
  ]
})
export default class DialogNewBoletoEspecial extends Vue {
  @Prop({ type: Object })
  private info!: BoletoEspecialDTO
  @Prop({ type: Boolean })
  private update!: boolean

  private name: string = 'DialogNewBoletoEspecial'

  private mInfo: BoletoEspecialDTO = {
    name: '',
    folioBeg: 0,
    folioEnd: 0,
    comment: '',
    respName: '',
    respEmail: '',
    respPassword: '',
    status: true
  }

  private bInfo: BoletoEspecialDTO = {
    name: '',
    folioBeg: 0,
    folioEnd: 0,
    comment: '',
    respName: '',
    respEmail: '',
    respPassword: '',
    status: true
  }

  private textMSG: TextMSGDTO = {
    success: {
      text: 'Nuevo Boleto:',
      color: 'success'
    },
    update: {
      text: 'Modificado Boleto:',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar:',
      color: 'error'
    },
  }

  private dialog: boolean = false
  private action: string = 'new'
  private titleNew: string = 'Agregar Boleto Especial'
  private titleMod: string = 'Modificar Boleto Especial'

  @Watch('info')
  private watchInfo (v: any) {
    console.log('watchInfo :: ', v)
    if (v !== null) {
      this.mInfo = v
      this.action = 'edit'
      this.dialog = true
    }
  }

  @Watch('mInfo.folioBeg')
  private watchFolioBeg (v: number) {
    console.log('watchFolioBeg :: ', v)
    this.getFolioError()
  }

  @Watch('mInfo.folioEnd')
  private watchFolioEnd (v: number) {
    console.log('watchFolioEnd :: ', v)
    this.getFolioError()
  }

  @Watch('dialog')
  private watchDialog (v: any) {
    if (!v) {
      this.action = 'new'
      this.mInfo = this.bInfo
    }
  }

  @Emit('update')
  private emitUpdate (v: boolean) {
    console.log('emitUpdate :: ', v)
    if (v) {
      this.dialog = false
      this.$emit('update:update', v)
    }
  }

  private getFolioError () {
    if (this.mInfo.folioEnd <= 0) {
      // @ts-ignore: Unreachable code error
      this.textError.folioEnd.show = true
      // @ts-ignore: Unreachable code error
      this.textError.folioEnd.message = 'El Folio Final no puede ser ZERO.'
    } else if (this.mInfo.folioBeg <= 0) {
      // @ts-ignore: Unreachable code error
      this.textError.folioBeg.show = true
      // @ts-ignore: Unreachable code error
      this.textError.folioBeg.message = 'El Folio Inicial no puede ser ZERO.'
    } else if (this.mInfo.folioEnd <= this.mInfo.folioBeg) {
      // @ts-ignore: Unreachable code error
      this.textError.folioEnd.show = true
      // @ts-ignore: Unreachable code error
      this.textError.folioEnd.message = 'El Folio Final tiene que ser mayor al folio inicial.'
    } else if (this.mInfo.folioBeg >= this.mInfo.folioEnd) {
      // @ts-ignore: Unreachable code error
      this.textError.folioBeg.show = true
      // @ts-ignore: Unreachable code error
      this.textError.folioBeg.message = 'El Folio Inicial tiene que ser menor al folio final.'
    } else {
      // @ts-ignore: Unreachable code error
      this.textError.folioBeg.show = false
      // @ts-ignore: Unreachable code error
      this.textError.folioBeg.message = ''
      // @ts-ignore: Unreachable code error
      this.textError.folioEnd.show = false
      // @ts-ignore: Unreachable code error
      this.textError.folioEnd.message = ''
    }
  }

  private Save (item: BoletoEspecialDTO) {
    console.log('Save :: ', item)
    HTTP.post('boleto-especial/', item)
      .then((response) => {
        console.log('CreateBoleto :: response :: ', response.data)
        this.emitUpdate(response.data.success)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.success.text + ' ' + item.name,
          color: this.textMSG.success.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('CreateBoleto :: catch :: ', e.response.data)
        // @ts-ignore: Unreachable code error
        this.textError = this.getError(e.response.data.message)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    if (this.info !== null) this.mInfo = this.info
  }
}
